import React, { useState } from 'react';
import { Flex } from 'reflexbox';
import styled from 'styled-components';

import { SmallButton } from '../components/BranchComponents';

import { isTimeslotValid } from '../../../helpers';

const NewTimeslotCreator = ({ onSubmit, onCancel }) => {
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');

  const createTimeslotHandler = setFunction => e => {
    const { value } = e?.target;

    setFunction(prevValue => {
      if (prevValue.length === 1 && value.length === 2 && value.search(/:/) === -1) {
        return value + ':';
      }

      return value;
    });
  };

  const timeslotSubmitHandler = e => {
    e.preventDefault();

    const timeslot = { start: startTime, end: endTime };

    onSubmit(timeslot);
  };

  return (
    <TimeslotForm onSubmit={timeslotSubmitHandler}>
      <TimeslotInput
        placeholder="12:00"
        value={startTime}
        onChange={createTimeslotHandler(setStartTime)}
      />
      <Separator>-</Separator>
      <TimeslotInput
        placeholder="15:00"
        value={endTime}
        onChange={createTimeslotHandler(setEndTime)}
      />
      <ButtonContainer>
        <SmallButton disabled={!isTimeslotValid(startTime, endTime)} type="submit">
          Add
        </SmallButton>
        <SmallButton onClick={onCancel} type="button">X</SmallButton>
      </ButtonContainer>
    </TimeslotForm>
  );
};

const TimeslotForm = styled.form`
  position: relative;
  padding: 0 11px;
  padding-top: 2px;
  padding-bottom: 6px;

  border-radius: 3px;

  color: white;
  font-weight: 600;

  background-color: #4db181;
`;

const Separator = styled.span`
  margin: 0 2px;
  color: white;
`;

const TimeslotInput = styled.input.attrs({
  maxLength: 5
})`
  width: 35px;
  padding: 2px;
  background: none;
  border: none;
  color: white;
  outline: none;
  border-bottom: 1px solid white;
`;

const ButtonContainer = styled(Flex)`
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  transform: translateY(110%);
  justify-content: space-between;
`;

export default NewTimeslotCreator;
